import React from "react";
import Container from "@mui/material/Container";
import { useNavigate } from "react-router-dom";
import EmptyState from "./global/EmptyState";
import GlassCard from "./global/GlassCard";

const ErrorNotFound = () => {
  const navigate = useNavigate();

  return (
    <Container component="main" maxWidth="xs">
      <GlassCard sx={{ mt: 8 }}>
        <EmptyState
          type="error"
          message="404 - Page Not Found"
          action={{
            label: "Back to Home",
            onClick: () => navigate("/"),
          }}
        />
      </GlassCard>
    </Container>
  );
};
export default ErrorNotFound;
